(ns frontend.view.reports.custom.alj-2.deals-presented-to-CIC-this-year-per-bu-table
  (:require
   [common.entity :as entity]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.view.reports.custom.alj :as alj]
   [frontend.view.reports.custom.alj-2.alj-components :as alj-components]
   [frontend.view.reports.custom.alj-2.utils :as alj-utils]
   [frontend.zap-time :as zap-time]))

(defn oppos-presented-to-CIC-this-year
  []
  (let [now (zap-time/now)
        this-year-js (.getYear (js/Date. now))]
    (->> (alj/all-deals)
         (filter (fn [oppo]
                   (when-let [presented-to-CIC-on (:oppo/date-CIC-presentation oppo)]
                     (let [prestented-dt (js/Date. presented-to-CIC-on)]
                       (and (< presented-to-CIC-on now)
                            (= this-year-js (.getYear prestented-dt)))))))
         (doall))))

(defn oppos-presented-to-CIC
  []
  (->> (alj/all-deals)
       (filter (fn [oppo]
                 (:oppo/date-CIC-presentation oppo)))
       (doall)))

(defn approved-and-closed?
  [oppo]
  (and (= :oppo.status/portfolio (:oppo/status oppo))
       (= "Approved"
          (->> oppo
               :oppo/CIC-recommendation
               (get @session/entities)
               :named-value/value))))                       ;; need definition

(defn active-deal?
  [oppo]
  (and (some #{(:oppo/status oppo)} [:oppo.status/ok :oppo.status/on-hold])
       (not= "Declined"
             (->> oppo
                  :oppo/CIC-recommendation
                  (get @session/entities)
                  :named-value/value))))                    ;; need definition

(defn declined-by-CIC?
  [oppo]
  (= "Declined"
     (->> oppo
          :oppo/CIC-recommendation
          (get @session/entities)
          :named-value/value)))                             ;; need definition

(defn report-sort
  [a b]
  (let [label-a (first a)
        label-b (first b)
        total-a (second a)
        total-b (second b)]
    (if (not= total-a total-b)
      (compare total-b total-a)                             ;; greatest first
      (compare label-a label-b))))

(defn row-data
  [oppos label]
  (let [total-count (count oppos)
        approved-count (->> oppos
                            (filter approved-and-closed?)
                            (count))
        active-count (->> oppos
                          (filter active-deal?)
                          (count))
        approve-% (int (* 100 (/ approved-count total-count)))
        declined-count (->> oppos
                            (filter declined-by-CIC?)
                            (count))]
    [label total-count approved-count active-count approve-% declined-count]))

(defn report
  [{:keys [state]}]
  (let [date-state-atom (alj-utils/date-state-defaults
                         state
                         [[:date-created #{} [:entity.type/oppo]]
                          [:date-cic #{:entity.type/oppo} [:entity.type/oppo]]
                          [:date-portfolio #{} [:entity.type/oppo]]])]
    (fn [{:keys [state]}]
      (let [deals (->> (alj/all-deals)
                       (cu/remove-by :oppo/status :oppo.status/on-hold)
                       (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :entity.type/oppo)
                       (alj-utils/deals-in-date-range-if-configured :oppo/date-CIC-presentation @date-state-atom :date-cic :entity.type/oppo)
                       (alj-utils/deals-in-date-range-if-configured :oppo/moved-to-portfolio-on @date-state-atom :date-portfolio :entity.type/oppo))
            ;oppos (->> (oppos-presented-to-CIC) (alj-utils/deals-in-date-range :oppo/date-CIC-presentation date-state-atom))

            active-business-units (session/non-archived-named-values :oppo/group-business-units (alj/alj-report-pipeline-id))
            active-business-unit-ids (->> active-business-units
                                          (map :db/id)
                                          (set))
            oppos-by-business-unit (->> deals
                                        (mapcat (fn [oppo]
                                                  (->> oppo
                                                       :oppo/group-business-units
                                                       (map (fn [bu-id]
                                                              [bu-id oppo])))))
                                        (group-by first)
                                        (map (fn [[bu-id bu-id-oppos]]
                                               [bu-id
                                                (->> bu-id-oppos
                                                     (map second)
                                                     (doall))]))
                                        (into {}))
            business-units-deals-data (->> active-business-units
                                           (map (fn [bu]
                                                  (let [bu-oppos (get oppos-by-business-unit (:db/id bu))]
                                                    (row-data bu-oppos (entity/display-string bu)))))
                                           (sort report-sort))
            oppos-without-active-bu (->> deals
                                         (remove (fn [oppo]
                                                   (some active-business-unit-ids (:oppo/group-business-units oppo)))))
            no-active-bu-data (when (seq oppos-without-active-bu)
                                (row-data oppos-without-active-bu (loc/tr :oppos-without-active-group-business-unit)))
            duplicate-bus (->> deals
                               (filter (fn [oppo]
                                         (> (count (:oppo/group-business-units oppo)) 1))))
            duplicate-bus-data (when (seq duplicate-bus)
                                 (row-data duplicate-bus (loc/tr :oppos-with-duplicate-business-units)))]
        [alj-components/alj-card
         {:view-name       "Total deals presented to IAC by SBU"
          :report-data     business-units-deals-data
          :date-state-atom date-state-atom
          :view            [:table.alj-report.zap-simple-table
                            [:thead
                             [:tr
                              [:th "SBU"]
                              [:th (loc/tr :total-number-of-deals)]
                              [:th (loc/tr :deals-approved-and-closed)]
                              [:th (loc/tr :active-deals)]
                              [:th (loc/tr :approve-percentage-of-total-presented)]
                              [:th (loc/tr :declined-by-CIC)]]]
                            [:tbody
                             (->> business-units-deals-data
                                  (map-indexed
                                   (fn [idx row-data]
                                     ^{:key (str "alj-2-presented-deals-this-year-per-bu-and-deal-type-bu-" idx)}
                                     [:tr
                                      {:class-name "alj-data-row"}
                                      (->> row-data
                                           (map-indexed (fn [cell-idx cell-data]
                                                          (let [no-data? (= 0 cell-data)]
                                                            ^{:key (str "alj-2-presented-deals-this-year-per-bu-and-deal-type-bu-" idx "-" cell-idx)}
                                                            [:td
                                                             {:class-name (fu/cs (when-not (= cell-idx 0)
                                                                                   "number-cell")
                                                                                 (when no-data?
                                                                                   "empty-cell")
                                                                                 (when (= cell-idx 1)
                                                                                   "highlight-cell"))}
                                                             (if no-data?
                                                               "-"
                                                               (str cell-data))])))
                                           (doall))]))
                                  (doall))]
                            [:tfoot
                             [:tr.alj-totals-row
                              (->> (row-data deals (loc/tr :grand-total))
                                   (map-indexed (fn [cell-idx cell-data]
                                                  ^{:key (str "alj-2-presented-deals-this-year-per-bu-and-deal-type-bu-totals" cell-idx)}
                                                  [:td
                                                   {:class-name (fu/cs (when-not (= cell-idx 0)
                                                                         "number-cell"))}
                                                   (str cell-data)]))
                                   (doall))]
                             (when no-active-bu-data        ;; What does customer want to do with this?
                               [:tr.alj-error-row
                                (->> no-active-bu-data
                                     (map-indexed (fn [cell-idx cell-data]
                                                    ^{:key (str "alj-2-presented-deals-this-year-per-bu-and-deal-type-bu-unknown-bus-" cell-idx)}
                                                    [:td
                                                     {:class-name (fu/cs (when-not (= cell-idx 0)
                                                                           "number-cell"))}
                                                     (str cell-data)]))
                                     (doall))])
                             (when duplicate-bus-data       ;; What does customer want to do with this?
                               [:tr.alj-duplicate-row
                                (->> duplicate-bus-data
                                     (map-indexed (fn [cell-idx cell-data]
                                                    ^{:key (str "alj-2-presented-deals-this-year-per-bu-and-deal-type-bu-duplicate-bus-" cell-idx)}
                                                    [:td
                                                     {:class-name (fu/cs (when-not (= cell-idx 0)
                                                                           "number-cell"))}
                                                     (str cell-data)]))
                                     (doall))])]]}]))))
